import { IconProps } from '../types';

function ContrastSolidIcon({ className, id }: IconProps) {
  return (
    <svg
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className || 'h-5 w-5'}
    >
      <path
        fillRule="evenodd"
        d="M10 2c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm6 8c0 3-2.2 5.4-5 5.9V4.1c2.8.5 5 2.9 5 5.9z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default ContrastSolidIcon;
